import { signOut as amplifySignOut } from 'aws-amplify/auth';

export async function signOut() {
  await amplifySignOut({ global: true });
}
